import { render } from "./BorderCrossing.vue?vue&type=template&id=29b2bc5a&scoped=true&ts=true"
import script from "./BorderCrossing.vue?vue&type=script&lang=ts"
export * from "./BorderCrossing.vue?vue&type=script&lang=ts"

import "@/assets/scss/report-grid.scss?vue&type=style&index=0&id=29b2bc5a&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b2bc5a"]])

export default __exports__